import * as React from 'react';
export const satispaySvg = React.forwardRef(function satispaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FF3D00',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.679 26.996h6.05l9.56-9.199c.478-.46.753-1.116.753-1.796 0-.681-.275-1.337-.753-1.797l-9.56-9.198H9.68a.455.455 0 0 0-.43.31.498.498 0 0 0 .118.534l10.24 9.854a.42.42 0 0 1 0 .598l-10.24 9.854a.49.49 0 0 0-.118.534c.055.15.196.31.43.31v-.004Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm11.52 9.614-4.767 4.587A2.502 2.502 0 0 0 6 15.997c0 .681.275 1.337.753 1.797l4.768 4.587 3.617-3.483-2.705-2.604a.42.42 0 0 1 0-.598l2.705-2.604-3.617-3.482v.004ZM22.363 5h-4.87l3.028 2.915 2.152-2.07a.496.496 0 0 0 .12-.534.455.455 0 0 0-.43-.31Zm-1.842 19.08-3.028 2.915h4.87a.455.455 0 0 0 .43-.31.496.496 0 0 0-.12-.534l-2.152-2.07Z',
      fill: '#fff',
    }),
  );
});
satispaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var satispay = {
  category: 'brand',
  colorable: false,
  name: 'satispay',
  svg: satispaySvg,
};
